











































import { Component, Prop } from 'vue-property-decorator';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'Schedule' })
export default class extends SaascadaVue {

    @Prop({required: true})
    scheduleInstallments: [];

    @Prop({required: true})
    totalSchedulesPages: number;

    headers = [
        { text: this.$t('pageText.lendingAccounts.fields.installmentNumber'), width: "10%" },
        { text: this.$t('pageText.lendingAccounts.fields.type'), width: "15%" },
        { text: this.$t('pageText.lendingAccounts.fields.date'), width: "15%" },
        { text: this.$t('pageText.lendingAccounts.fields.payment'), width: "15%" },
        { text: this.$t('pageText.lendingAccounts.fields.principal'), width: "15%" },
        { text: this.$t('pageText.lendingAccounts.fields.interest'), width: "15%" },
        { text: this.$t('pageText.lendingAccounts.fields.balance'), width: "20%" }
    ];
    schedulesPage = 1;

    get pageSize() {
        return LendingAccountModule.pageSize;
    }

    get loading() {
        return LendingAccountModule.loadingSchedule;
    }

}
